<template>
<nav aria-labelledby="meta-hamburger"
        id="meta-nav"
        :class="cssClass" :aria-hidden="!visible" >
    <div class="wrapper">

        <!-- <div class="logo" v-show="!logoVisible" v-if="visible"> -->
        <router-link v-show="!logoVisible" v-if="visible" :to="{name: 'home'} " aria-label="home" role="link">
            <div class="logo"></div>
        </router-link>
        <!-- </div> -->
    
        <div class="activities" v-if="visible">
            <hr class="hr-25" :aria-hidden="true" />
            <h3>Activities</h3>
            <ul class="unstyled activityLinks">
                <li><router-link :to="{name: 'state_4b'}">{{ $t("wv_2b_01") }}</router-link></li>
                <li><router-link :to="{name: 'state_2f'}">{{ $t("wv_2f_01") }}</router-link></li>
            </ul>
        </div>

        <ul style="display: none;" aria-hidden="true">
            <li><router-link :to="{name: 'state_4b_a'}"></router-link></li>
            <li><router-link :to="{name: 'state_4b_b'}"></router-link></li>
            <li><router-link v-for="index in sstLayers" 
                            :key="'explore' + index" 
                            :to="{ name: 'state_4b_c', params: { index: index - 1 } }">
            </router-link></li>
            <li><router-link :to="{name: 'state_4b_d'}"></router-link></li>
            <li><router-link :to="{name: 'state_4b_e'}"></router-link></li>

            <li><router-link :to="{name: 'state_2f_a'}"></router-link></li>
            <li><router-link :to="{name: 'state_2f_b'}"></router-link></li>
            <li><router-link :to="{name: 'state_2f_c'}"></router-link></li>
            <li><router-link v-for="index in otolithCount"
                            :key="'trace' + index" 
                            :to="{ name: 'state_2f_d', params: { index: index - 1 } }">
            </router-link></li>
            <li><router-link :to="{name: 'state_2f_e'}"></router-link></li>
            <li><router-link :to="{name: 'state_2f_f'}"></router-link></li>
            <li><router-link :to="{name: 'state_2f_g'}"></router-link></li>

        </ul>
    </div>
</nav>
</template>


<script>
import { mapGetters } from 'vuex'
import Sst from "@/models/sst"
import Otolith from "@/models/otolith/otolith"

export default {
    name: 'Nav',
    computed: {
        ...mapGetters({
            'visible': 'global/nav_visible',
            'logoVisible': 'global/logo_visible',
        }),
        cssClass() {
            return this.visible ? 'visible' : 'hidden'
        },
        sstLayers(){
            return Sst.getLayerCount();
        },
        otolithCount(){
            return Otolith.getStudentModel().length;
        }
    },
    methods: {
        handleEsc: function(e) {
            console.log("Esc")
        }
    }
}
</script>


<style scoped lang="scss">
@import "@/assets/styles/_vars.scss";

nav {
    width: 40%;
    backdrop-filter: blur(5px);
    background-color: $color-blue-darkest-scrim;
    position: fixed;
    height: 100%;
    right: 0;
    top: 0;
    transition: $transition-default;
    z-index: 9000;

    &.hidden {
        transform: translateX(100%);
    }
    &.visible {
        right: 0;
    }
    .wrapper {
        padding: ($s4 * 3) $s4 $s4 $s4;
    }


    @media screen and (max-width: 1100px) {
        width: 30%;
    }
    
}

.activities{
    margin-top: 50px;
}

.activityLinks{
    li{
        padding-bottom: 5px;
        font-size: 1rem;
        line-height: 1.7rem;
        margin-bottom: 10px;
    }
}

</style>
